define 'controller/InputValidateController', ['jquery'], ($) ->
  class InputValidateController
  
    constructor: (@$el) ->
      @_greenTickOnLoad()
      @_greenTickKeyUpCheck()
      
    _greenTickOnLoad: ->
      self = this
      $('body .js-green-tick').each (e) ->
        pattern = $(this).data('tick-pattern')
        input = $(this)
        if !pattern
          return
        hasError = $(this).hasClass('error')
        if hasError
          return
        regex = new RegExp(self._getPatternRegex(pattern))
        self._tickUntick $(this), regex.test(input.val())
      return

    _greenTickKeyUpCheck: ->
      self = this
      $('body').on 'keyup', '.js-green-tick', (e) ->
        input = $(this)
        $(this).removeClass('error')
        $(this).closest('.input-field').find('div.error').hide()
        pattern = $(this).data('tick-pattern')
        if !pattern
          return
        regex = new RegExp(self._getPatternRegex(pattern))
        self._tickUntick $(this), regex.test(input.val())
      return

    _tickUntick: (el, doTick) ->
      if doTick
        $(el).addClass 'success'
      else
        if $(el).hasClass('success')
          $(el).removeClass 'success'
      return

    _getPatternRegex: (pattern) ->
      if pattern == '@'
        return new RegExp(/^[a-zA-Z0-9][a-zA-Z0-9-_\.]+@([a-zA-Z]|[a-zA-Z0-9]?[a-zA-Z0-9-]+[a-zA-Z0-9])\.[a-zA-Z0-9]{2,10}(?:\.[a-zA-Z]{2,10})?$/)
      if pattern == 'char'
        return new RegExp(/^[a-zA-ZÀ-ÿ]{1,5}/)
      if pattern == 'dig'
        return new RegExp(/^[0-9]/)
      if pattern == 'zip'
        return new RegExp(/^[0-9]{5}/)
      if pattern == 'birth'
        return new RegExp(/^[0-9]{2}\/[0-9]{2}\/[0-9]{4}/)
      if pattern == 'tel'
        return new RegExp(/^[0-9]{10}/)
      new RegExp(pattern)
    
    destroy: ->
      @$el.off()